// extracted by mini-css-extract-plugin
export default {"calendarSection":"Calendar_calendarSection__zpLul","header":"Calendar_header__1Ch9r","week":"Calendar_week__tZEEa","days":"Calendar_days__qGMR5"};